import styles from "./style.module.css";
import ax1 from "assets/images/pinli.svg";
import ax2 from "assets/images/purpl.svg";
import ax3 from "assets/images/blui.svg";
import ax4 from "assets/images/sormi.svg";
// import l1 from "assets/images/l1 (4).svg";
// import l2 from "assets/images/l1 (2).svg";
// import l3 from "assets/images/l1 (3).svg";
// import l4 from "assets/images/l1 (1).svg";
const Statistics = ({ title, icon, color, type, txt, number }) => {
  let pic;
  switch (type) {
    case 1:
      pic = ax1;
      break;
    case 2:
      pic = ax2;
      break;
    case 3:
      pic = ax3;
      break;
    case 4:
      pic = ax4;
      break;
  }

  return (
    <div className="container m-auto  my-4">
      <div
        className={`d-flex flex-column justify-content-evenly align-items-center text-light ${styles.cryptCard2} `}
      >
        <img src={pic} className={styles.ax1} />
        <div className={styles.up}>
          <div className="w-100 pt-2 px-3">{title}</div>
          <div className=" pt-2 px-3 d-flex flex-column text-center ">
            <div
              className="bg-white d-flex justify-content-center align-items-center"
              style={{
                width: "73px",
                height: "73px",
                borderRadius: "50%",
                marginBottom: "10px",
              }}
            >
              <img src={icon} style={{ width: "50px", height: "50px" }} />
            </div>
            <p style={{ fontSize: "15px" }}>{number}</p>
            <p style={{ fontSize: "15px" }}>{txt} </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;

{
  /* <div className=" row ">
        <div className="col-lg-3 col-md-6 col-sm-12 my-2 ">
          <div
            className={`d-flex flex-column justify-content-evenly align-items-center text-light ${styles.cryptCard2} `}
          >
            <img src={ax1} className={styles.ax1} />
            <div className={styles.up}>
              <div className="w-100 pt-2 px-3">تعداد کل تامین کنندگان</div>
              <div className=" pt-2 px-3 d-flex flex-column text-center ">
                <div
                  className="bg-white d-flex justify-content-center align-items-center"
                  style={{
                    width: "73px",
                    height: "73px",
                    borderRadius: "50%",
                    marginBottom: "10px",
                  }}
                >
                  <img src={l1} style={{ width: "50px", height: "50px" }} />
                </div>
                <p style={{ fontSize: "15px" }}>145</p>
                <p style={{ fontSize: "15px" }}>تامین کننده </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 my-2 ">
          <div
            className={`d-flex flex-column justify-content-evenly align-items-center text-light ${styles.cryptCard2} `}
          >
            <img src={ax2} className={styles.ax1} />
            <div className={styles.up}>
              <div className="w-100 pt-2 px-3">تعداد تامین کنندگان فعال</div>
              <div className=" pt-2 px-3 d-flex flex-column text-center ">
                <div
                  className="bg-white d-flex justify-content-center align-items-center"
                  style={{
                    width: "73px",
                    height: "73px",
                    borderRadius: "50%",
                    marginBottom: "10px",
                  }}
                >
                  <img src={l3} style={{ width: "50px", height: "50px" }} />
                </div>
                <p style={{ fontSize: "15px" }}>145</p>
                <p style={{ fontSize: "15px" }}>تامین کننده فعال</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 my-2 ">
          <div
            className={`d-flex flex-column justify-content-evenly align-items-center text-light ${styles.cryptCard2} `}
          >
            <img src={ax3} className={styles.ax1} />
            <div className={styles.up}>
              <div className="w-100 pt-2 px-3">تعداد سوپر مارکت ها</div>
              <div className=" pt-2 px-3 d-flex flex-column text-center ">
                <div
                  className="bg-white d-flex justify-content-center align-items-center"
                  style={{
                    width: "73px",
                    height: "73px",
                    borderRadius: "50%",
                    marginBottom: "10px",
                  }}
                >
                  <img src={l2} style={{ width: "50px", height: "50px" }} />
                </div>
                <p style={{ fontSize: "15px" }}>145</p>
                <p style={{ fontSize: "15px" }}>سوپر مارکت </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 my-2 ">
          <div
            className={`d-flex flex-column justify-content-evenly align-items-center text-light ${styles.cryptCard2} `}
          >
            <img src={ax4} className={styles.ax1} />
            <div className={styles.up}>
              <div className="w-100 pt-2 px-3">تعداد پروتئینی ها</div>
              <div className=" pt-2 px-3 d-flex flex-column text-center ">
                <div
                  className="bg-white d-flex justify-content-center align-items-center"
                  style={{
                    width: "73px",
                    height: "73px",
                    borderRadius: "50%",
                    marginBottom: "10px",
                  }}
                >
                  <img src={l4} style={{ width: "50px", height: "50px" }} />
                </div>
                <p style={{ fontSize: "15px" }}>145</p>
                <p style={{ fontSize: "15px" }}>پروتئین </p>
              </div>
            </div>
          </div>
        </div>
      </div> */
}
